/* __simplici_cdn_links__
 * Local replacement for admin.panel/src/constant/links.ts (applied by
 * _infra/patch-admin-cdn-links.sh at bootstrap step 7 — never hand-edit the
 * clone). Upstream's version had two defects in one line:
 *
 *   const API_CDN_SCRIPT =
 *     (window as any)?.__ENV?.REACT_APP_CDN_URL + '/images/scripts' ?? '';
 *
 * 1. It read window.__ENV directly, but admin.panel's start script does not run
 *    react-env, so window.__ENV is undefined and the value is never found even
 *    though every other env in the app resolves fine (react-env's env() falls
 *    back to the CRA-inlined process.env object when window.__ENV is absent).
 * 2. `a + b ?? ''` parses as `(a + b) ?? ''` — string concatenation never
 *    yields null/undefined, so the fallback can never fire and the result was
 *    the literal string "undefined/images/scripts". The CRA dev server answers
 *    unknown paths with index.html, which the <script> tags then parsed as JS:
 *    "Uncaught SyntaxError: Unexpected token '<'".
 *
 * Fix: resolve CDN_URL through the same env() helper the rest of the app uses,
 * and when no CDN is configured export an empty list — InjectScript([]) is a
 * documented no-op, so LuckySheet simply does not load rather than loading a
 * broken URL.
 */
import env from '@beam-australia/react-env';

const CDN_URL = env('CDN_URL');
const API_CDN_SCRIPT = CDN_URL ? `${CDN_URL}/images/scripts` : '';

export const LuckySheetLinks = API_CDN_SCRIPT
	? [
			{
				type: 'script',
				link: API_CDN_SCRIPT + '/luckysheet.plugins.js',
			},
			{
				type: 'script',
				link: API_CDN_SCRIPT + '/luckysheet.plugins.umd.js',
			},
			{
				type: 'link',
				link: API_CDN_SCRIPT + '/luckysheet.pluginscss.css',
			},
			{
				type: 'link',
				link: API_CDN_SCRIPT + '/luckysheet.css',
			},
			{
				type: 'link',
				link: API_CDN_SCRIPT + '/luckysheet.plugins.css',
			},
			{
				type: 'link',
				link: API_CDN_SCRIPT + '/luckysheet.iconfont.css',
			},
	  ]
	: [];
